import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, Lock, User, Phone, ArrowRight } from 'lucide-react';
export function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Authentication system is coming soon! This is a preview.');
  };
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3
      }
    }
  };
  return <main className="min-h-screen pt-32 pb-20 px-6 flex items-center justify-center" data-id="element-95">
      <div className="w-full max-w-md" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-10" data-id="element-97">
          <h1 className="text-4xl font-heading tracking-widest text-white mb-2" data-id="element-98">
            ALEKS SZULC
          </h1>
          <p className="text-gray-400 font-body text-sm uppercase tracking-wider" data-id="element-99">
            Athlete Portal
          </p>
        </motion.div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 shadow-2xl relative overflow-hidden" data-id="element-100">
          {/* Accent line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-accent-blue to-accent-gold" data-id="element-101" />

          <AnimatePresence mode="wait" data-id="element-102">
            <motion.div key={isLogin ? 'login' : 'signup'} variants={containerVariants} initial="hidden" animate="visible" exit="exit" data-id="element-103">
              <h2 className="text-3xl font-heading text-white mb-6 text-center" data-id="element-104">
                {isLogin ? 'WELCOME BACK' : 'CREATE ACCOUNT'}
              </h2>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-105">
                {!isLogin && <div className="space-y-5" data-id="element-106">
                    <div data-id="element-107">
                      <label className="block text-sm font-body text-gray-400 mb-2" data-id="element-108">
                        Full Name
                      </label>
                      <div className="relative" data-id="element-109">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-110">
                          <User className="h-5 w-5 text-gray-500" data-id="element-111" />
                        </div>
                        <input type="text" required value={name} onChange={e => setName(e.target.value)} className="w-full bg-dark-primary border border-dark-border rounded-lg pl-11 pr-4 py-3 text-white font-body focus:outline-none focus:border-accent-blue transition-colors" placeholder="John Doe" data-id="element-112" />
                      </div>
                    </div>
                    <div data-id="element-113">
                      <label className="block text-sm font-body text-gray-400 mb-2" data-id="element-114">
                        Phone Number
                      </label>
                      <div className="relative" data-id="element-115">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-116">
                          <Phone className="h-5 w-5 text-gray-500" data-id="element-117" />
                        </div>
                        <input type="tel" required value={phone} onChange={e => setPhone(e.target.value)} className="w-full bg-dark-primary border border-dark-border rounded-lg pl-11 pr-4 py-3 text-white font-body focus:outline-none focus:border-accent-blue transition-colors" placeholder="+48 123 456 789" data-id="element-118" />
                      </div>
                    </div>
                  </div>}

                <div data-id="element-119">
                  <label className="block text-sm font-body text-gray-400 mb-2" data-id="element-120">
                    Email Address
                  </label>
                  <div className="relative" data-id="element-121">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-122">
                      <Mail className="h-5 w-5 text-gray-500" data-id="element-123" />
                    </div>
                    <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-dark-primary border border-dark-border rounded-lg pl-11 pr-4 py-3 text-white font-body focus:outline-none focus:border-accent-blue transition-colors" placeholder="you@example.com" data-id="element-124" />
                  </div>
                </div>

                <div data-id="element-125">
                  <label className="block text-sm font-body text-gray-400 mb-2" data-id="element-126">
                    Password
                  </label>
                  <div className="relative" data-id="element-127">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-128">
                      <Lock className="h-5 w-5 text-gray-500" data-id="element-129" />
                    </div>
                    <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-dark-primary border border-dark-border rounded-lg pl-11 pr-4 py-3 text-white font-body focus:outline-none focus:border-accent-blue transition-colors" placeholder="••••••••" data-id="element-130" />
                  </div>
                </div>

                {!isLogin && <div data-id="element-131">
                    <label className="block text-sm font-body text-gray-400 mb-2" data-id="element-132">
                      Confirm Password
                    </label>
                    <div className="relative" data-id="element-133">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-134">
                        <Lock className="h-5 w-5 text-gray-500" data-id="element-135" />
                      </div>
                      <input type="password" required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-dark-primary border border-dark-border rounded-lg pl-11 pr-4 py-3 text-white font-body focus:outline-none focus:border-accent-blue transition-colors" placeholder="••••••••" data-id="element-136" />
                    </div>
                  </div>}

                {isLogin && <div className="flex justify-end" data-id="element-137">
                    <button type="button" className="text-sm font-body text-accent-blue hover:text-white transition-colors" data-id="element-138">
                      Forgot password?
                    </button>
                  </div>}

                <button type="submit" className="w-full flex items-center justify-center gap-2 bg-accent-blue text-black font-heading tracking-wider text-lg py-4 rounded-lg hover:bg-accent-blue-hover transition-colors mt-6" data-id="element-139">
                  {isLogin ? 'LOG IN' : 'CREATE ACCOUNT'}
                  <ArrowRight className="w-5 h-5" data-id="element-140" />
                </button>
              </form>

              <div className="mt-8 text-center" data-id="element-141">
                <p className="text-gray-400 font-body text-sm" data-id="element-142">
                  {isLogin ? "Don't have an account? " : 'Already have an account? '}
                  <button onClick={() => setIsLogin(!isLogin)} className="text-accent-blue hover:text-white font-medium transition-colors" data-id="element-143">
                    {isLogin ? 'Sign up' : 'Log in'}
                  </button>
                </p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </main>;
}